export const TESTS_PER_PAGE = 30;
